import React, { useState } from "react";
import emailjs from "@emailjs/browser";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [emailError, setEmailError] = useState("");

   // Email validation regex
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  

    // Clear error while typing
    if (e.target.name === "email") {
      setEmailError("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 🔴 VALIDATION
    if (!formData.email) {
      setEmailError("Email is required");
      return;
    }

    if (!validateEmail(formData.email)) {
      setEmailError("Enter a valid email address");
      return;
    }

    setLoading(true);
    setSuccess(false);

    emailjs.send(
      "service_s9ojob8",     // same service ID
      "template_z25bkri",   // ⚠️ create new template OR reuse carefully
      {
        user_name: formData.name,
        user_email: formData.email,
        subject: formData.subject,
        message: formData.message,
      },
      "VzkKwdWM6vTHc9IF-"   // same public key
    )
    .then(() => {
      setSuccess(true);
      setLoading(false);
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    })
    .catch((error) => {
      console.error(error);
      setLoading(false);
    });
  };

  return (
    <div className="contact-information">
      <div className="container">
        <div className="row">

          {/* FORM */}
          <div className="col-lg-6 col-xl-6">
            <div className="contact-form">
              <h3>Have Any Queries</h3>

              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-12">
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-xl-6">
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-xl-6">
                    <input
                      type="text"
                      name="subject"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <textarea
                      name="message"
                      rows={5}
                      placeholder="Your message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="submit"
                      value={loading ? "Sending..." : "Send Message"}
                    />
                  </div>

                </div>
              </form>

              {/* SUCCESS MESSAGE */}
              {success && (
                <p style={{ color: "green", marginTop: "10px" }}>
                  Thanks! Your message has been sent.
                </p>
              )}

            </div>
          </div>

          {/* MAP */}
          <div className="col-lg-6 col-xl-6">
            <div className="google-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28474.676247547264!2d75.78498367640276!3d26.861110634202113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db7b51669dee9%3A0x3708a6ae96453829!2sBhamashah%20Techno%20Hub!5e0!3m2!1sen!2sin!4v1776684006682!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ContactForm;